import React from 'react';
import BottomNav from '../components/BottomNav';

const Trade = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Trading Platform</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Premium Trading Services</p>
        
        <div className="card">
          <p>
            Access sophisticated trading platforms and premium market research. 
            Trade stocks, commodities, forex, and alternative assets with expert support.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Multi-Asset Trading</h3>
              <p>Stocks, commodities, forex, and cryptocurrencies</p>
            </div>
            <div className="feature-item">
              <h3>Research & Analysis</h3>
              <p>Premium market insights and trading signals</p>
            </div>
            <div className="feature-item">
              <h3>Dedicated Support</h3>
              <p>Personal trading advisors and 24/7 assistance</p>
            </div>
          </div>
          
          <button className="btn-primary" style={{width: '100%', marginTop: '2rem'}}>
            Access Trading Platform
          </button>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Trade;
